module.exports = __webpack_public_path__ + "static/media/dakshit.a850a411.jpeg";